import { render, staticRenderFns } from "./ConfigurationInfo.vue?vue&type=template&id=2d2589bf"
import script from "./ConfigurationInfo.vue?vue&type=script&lang=js"
export * from "./ConfigurationInfo.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports